<template>
  <div class="content-wrap" :style="{backgroundColor: bgcolor}">
    <div class="content-inner">
      <div class="md-content" v-html="content"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
/*     bgcolor: {
      type: String,
      default: '#2a59c4'
    } */
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  .content-inner {
    max-width: 1024px;
    //margin: 0 auto;
    padding: 0px 100px 0px 100px;/* 上右下左 */
    text-align: center;

    .md-content {
      text-align: justify;
      font-size: 15px;
      font-weight: 400;
      line-height: 23px;
    }


    @media screen and (max-width: 990px) {
      padding: 0px 10px;
    }
  }
}
</style>